import React, { useEffect, useState } from 'react';
import { Form } from "react-bootstrap";


const MaskReal = ({ onChange, value }) => {
    const [valor, setValor] = useState(0);

    useEffect(() => {
        if (value) {
            formatarValor(value);
        } else {
            formatarValor('R$ 0.0');
        };
    }, [value]);

    const formatarValor = (input) => {
        // Remove caracteres não numéricos
        const apenasNumeros = input.replace(/\D/g, '');

        // Formata o valor para o padrão monetário
        const valorFormatado = (parseInt(apenasNumeros) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        const valorNumerico = (parseFloat(apenasNumeros) / 100).toFixed(2);
        setValor(valorFormatado);
        onChange(valorNumerico);
    };

    const handleChange = (event) => {
        const input = event.target.value;
        formatarValor(input);
    };

    return (
        <div>
            <Form.Control
                type="text"
                value={valor}
                onChange={handleChange}
                placeholder="Digite o valor"
            />
        </div>
    );
};

export default MaskReal;
